export enum JobTitles {
  GET_JOB_TITLES_REQUEST = '@jobtitles/GET_JOB_TITLES_REQUEST',
  GET_JOB_TITLES_SUCCESS = '@jobtitles/GET_JOB_TITLES_SUCCESS',
  GET_JOB_TITLES_FAIL = '@jobtitles/GET_JOB_TITLES_FAIL',

  GET_ORG_JOB_TITLES_REQUEST = '@jobtitles/GET_ORG_JOB_TITLES_REQUEST',
  GET_ORG_JOB_TITLES_SUCCESS = '@jobtitles/GET_ORG_JOB_TITLES_SUCCESS',
  GET_ORG_JOB_TITLES_FAIL = '@jobtitles/GET_ORG_JOB_TITLES_FAIL',

  RESET_JOB_TITLES = '@jobtitles/RESET_JOB_TITLES',
}
